export enum PhoneNumberType {
  Inbound = 'inbound',
  Outbound = 'outbound',
}
